import { Component, OnInit } from '@angular/core';
import { Categoria } from '../../../../model/class/Categoria';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { Producto } from '../../../../model/class/Producto';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import * as _ from 'lodash';
import { ConfirmService } from '../../../services/confirm/confirm.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CategoriaProducto } from '../../../../model/class/CategoriaProducto';
import { ToastsManager } from 'ng2-toastr';

/*
Falta mantener los filtros de cada tab
y ver lo del seleccionar todos
 */

@Component({
  selector: 'app-lista-productos',
  templateUrl: './lista-productos.component.html',
  styleUrls: ['./lista-productos.component.css']
})
export class ListaProductosComponent implements OnInit {

  loader = {
    padres: true,
    intermedias: false,
    hijas: false,
    tabla: false,
    editar: false
  };

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();

  typeOperation = {
    filter: 'filtro',
    modify: 'modificar'
  };
  optPerPage = [10, 20, 50];
  currentTypeOperation = this.typeOperation.filter;
  selectAll = false;
  page = 1;
  perPage = 20;
  // perPage = this.optPerPage[1];
  totalData = 0;

  productosTodos: Producto[] = [];
  categoriasPadres: Categoria[] = [];

  catPadreSel: Categoria;
  catIntermediaSel: Categoria;
  catHijaSel: Categoria;

  selStatus = 'PUBLICADO';

  headerTable: any[] = [
    {
      text: 'Foto',
    }, {
      text: 'Nombre',
      value: 'nombre'
    }, {
      text: 'Categoría N1',
    }, {
      text: 'Categoría N2',
    }, {
      text: 'Categoría N3',
    }, {
      text: 'Prod. Relacionados',
      value: 'totalProductosRelacionados'
    }, {
      text: 'Prod. Complementarios',
      value: 'totalProductosComplementarios'
    }, {
      text: 'Códigos',
      value: 'totalCodigos'
    }, {
      text: 'Fotos y Videos',
      value: 'totalFotosVideos'
    }
  ];

  orderSelected: any;
  filtering = false;


  constructor(
    private categoriaService: CategoriaService,
    private productoService: ProductoService,
    private confirmService: ConfirmService,
    private toasts: ToastsManager,
  ) {
    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();
        this.loadProductos();
      });
  }

  ngOnInit() {
    this.categoriaService.getPadres()
      .subscribe(
        (data) => {
          for (const o of data) {
            this.categoriasPadres.push(new Categoria(o));
          }
        }
      );
    // this.loadProductos();
  }

  onTextoBuscarChange(texto: string) {
    this.textoBuscarChanged.next(texto);
  }

  loadProductos() {

    this.filtering = true;
    this.loader.tabla = true;
    this.productosTodos = [];
    const parametros: any = {};

    const filtro: any[] = [{ 'status': this.selStatus }];
    if (this.catHijaSel) {
      filtro.push({ 'daughter_category': this.catHijaSel.id });
    } else if (this.catIntermediaSel) {
      filtro.push({ 'intermediate_category': this.catIntermediaSel.id });
    } else if (this.catPadreSel) {
      filtro.push({ 'parent_category': this.catPadreSel.id });
    }
    let texto: string;

    if (this.textoBuscar) {
      texto = _.trim(this.textoBuscar);
    }
    parametros.filter = JSON.stringify(filtro);
    if (texto) {
      const objetoBucar: any[] = [{ 'name': texto }];
      parametros.search = JSON.stringify(objetoBucar);
    }

    const paginador = {
      since: (this.page - 1) * this.perPage,
      quantity: this.perPage
    };
    parametros.paginator = JSON.stringify(paginador);

    // Paginador recibe desde, catodad

    this.productoService.gatAll(parametros)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          this.totalData = response.total;
          for (const iprod of response.data) {
            this.productosTodos.push(new Producto(iprod));
          }
          this.orderData();
        }, (error) => {
          this.loader.tabla = false;
        }
      );
  }

  limpiarTexto() {
    this.textoBuscar = '';
    this.loadProductos();
  }

  changeTypeOperation(type: string) {
    this.currentTypeOperation = type;
  }

  loadDaughterCategories(parent: Categoria, nivel: number) {
    if (parent) {
      if (!parent.categoriasHijas || parent.categoriasHijas.length === 0) {

        if (nivel === 1) {
          this.loader.intermedias = true;
          this.catIntermediaSel = undefined;
        }
        this.loader.hijas = true;
        this.catHijaSel = undefined;

        this.categoriaService.getHijas(parent.id)
          .subscribe((data) => {
            parent.categoriasHijas = data;
            if (nivel === 1) {
              this.loader.intermedias = false;
            }
            this.loader.hijas = false;
          });
      } else {
        if (nivel === 1) {
          if (parent.categoriasHijas[0]) {
            // this.catIntermediaSel = parent.categoriasHijas[0];
            this.loadDaughterCategories(this.catIntermediaSel, 2);
          } else {
            this.loader.hijas = false;
          }
        }
      }
    }
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === 'desc') {
            this.headerTable[i].order = 'asc';
          } else if (this.headerTable[i].order === 'asc') {
            this.headerTable[i].order = 'desc';
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = 'asc';
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.productosTodos = _.orderBy(this.productosTodos, this.orderSelected.value, this.orderSelected.order);
    }
  }

  allSelected() {
    for (const prod of this.productosTodos) {
      prod.selected = this.selectAll;
    }
  }

  pageChange(event) {
    this.page = event;
    this.loadProductos();
  }

  aplicarCambios() {
    const seleccionados = _.filter(this.productosTodos, { 'selected': true });
    if (seleccionados.length > 0) {
      const titulo = `${seleccionados.length} producto(s) seleccioandos`;
      let msg = 'Se realizaran las siguientes acciones: <ul><li>Se cambiara a estado ';

      if (this.selStatus === 'PUBLICADO') {
        msg += 'Publicado.';
      } else {
        msg += 'No Publicado.';
      }
      msg += '</li>';

      if (this.catHijaSel) {
        msg += `<li>Se agregara a la categoria: ${this.catHijaSel.nombre}</li>`;
      }

      this.confirmService.confirm(titulo, msg).then((resp) => {
        if (resp) {

          const promEsitar = [];
          const formData = new FormData();
          console.log('this.selStatus', this.selStatus);
          formData.append('esPublicado', this.selStatus);

          for (const pord of seleccionados) {
            promEsitar.push(this.productoService.edit(pord.id, formData));
          }

          this.loader.editar = true;
          forkJoin(promEsitar)
            .subscribe(
              () => {
                if (this.catHijaSel) {
                  const promCatProd = [];
                  for (const pord of seleccionados) {
                    const pivot = new CategoriaProducto({ orden: 0, productoId: pord.id });
                    promCatProd.push(this.categoriaService.setProducto(this.catHijaSel.id, pivot.getFormData()));
                  }
                  forkJoin(promCatProd)
                    .subscribe(() => {
                      this.exitoEditar();
                    }, (error) => {
                      this.errorEditar(error);
                    });

                } else {
                  this.exitoEditar();
                }
              }, (error) => {
                this.errorEditar(error);
              }
            );
        }
      });

    }
  }

  private errorEditar(error?) {
    console.error(error)
    this.loader.editar = false;
    this.toasts.error('Error al aplicar los cambios');
  }

  private exitoEditar() {
    this.loader.editar = false;
    this.toasts.success('Cambios aplicados con exito');
    this.loadProductos();
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/lista-productos/lista-productos.component.ts